import { ServiceAppService } from '../../../security/service-app.service';
import { FileUpload } from '../../../shared/fileupload/fileupload';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import * as XLSX from 'xlsx';
import { Estado } from '../../../shared/shared/estado.enum';
import { ICadastro, IFiltros } from './interface-previsao-venda';

@Component({
  selector: 'app-previsao-venda',
  templateUrl: './previsao-venda.component.html',
  styleUrls: ['./previsao-venda.component.scss']
})

export class PrevisaoVendaComponent implements OnInit {
  cols: any[];
  first = 0;
  rows = 10;
  dados: any[];
  _selectedColumns: any[];
  loading: boolean;
  nomeModulo: any;
  progress = false;
  totalRegistros: any = 0;
  displayRows: number = 0;
  filtrosNew: IFiltros;
  state: Estado;
  cadastro: ICadastro;
  cadastroTitulo: string = '';
  definirFiltros: string = '';
  exibeFiltros: boolean = false;
  exibeCadastro: boolean = false;
  tiposMarca: any[] = [];
  selectMarca: any = null;
  selectedDados: any[] = [];

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;
  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private service: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private config: PrimeNGConfig) {
    this.nomeModulo = 'previsao-venda';
  }

  ngOnInit(): void {
    const ano = new Date();
    this.filtrosNew = {
      id: '', id_dealer: '', id_categoria_venda: '', mes: '', ano: '', paginaAtual: 1,
      quantidadeRegistrosPorPagina: 10, anoNumber: ano.getFullYear()
    }
    this.retornaDados();

    this.cols = [
      { field: 'nome_dealer', header: 'Dealer' },
      { field: 'nome_categoria_venda', header: 'Categoria Venda' },
      { field: 'desc_modelo', header: 'Família' },
      { field: 'ano', header: 'Ano' },
      { field: 'mes', header: 'Mês' },
      { field: 'valor', header: 'Valor' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  onPageChange(event: any): void {
    this.filtrosNew.paginaAtual = event.page + 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = event.rows;
    this.displayRows = event.first;
    this.first = event.first;
    this.retornaDados();
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados(`/previsaoVenda?idDealer=${this.filtrosNew.id_dealer}&idCategoriaVenda=${this.filtrosNew.id_categoria_venda}&mes=${this.filtrosNew.mes}&ano=${this.filtrosNew.ano}&paginaAtual=${this.filtrosNew.paginaAtual}&quantidadeRegistrosPorPagina=${this.filtrosNew.quantidadeRegistrosPorPagina}`).subscribe(res => {
      this.totalRegistros = res.total_registros;
      this.dados = res.dados;

      this.loading = false;
    });
  }

  recarregaDados() {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.first = 0;

    this.retornaDados();
  }

  createDateFromMonth(month: number, year: number = new Date().getFullYear()): Date {
    const date = new Date(year, month - 1, 1);
    return date;
  }

  editDados(dado: ICadastro, estado: Estado) {
    console.log(dado)
    this.cadastroTitulo = estado === Estado.edit ? 'Editar' : estado === Estado.view ? 'Visualizar' : '';
    this.state = estado;
    this.cadastro = { ...dado };
    this.cadastro.mesDate = this.createDateFromMonth(dado.mes);
    this.exibeCadastro = true;
  }

  insertDados() {
    this.cadastroTitulo = 'Cadastrar';
    this.state = Estado.insert;
    this.cadastro = { todosDealer: false, id: null, id_categoria_venda: null, id_veiculos: null, ano: null, mes: null, tipo_valor: 'S', valor: null };
    this.exibeCadastro = true;
  }

  removerRegistro(event: any) {
    this.confirmationService.confirm({
      key: 'previsao-venda',
      message: 'Tem certeza de que deseja apagar o dado?',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.service.exclusao(`/previsaoVenda?idDealer=${event.id}&idCategoriaVenda=${event.id_categoria_venda}&mes=${event.mes}&ano=${event.ano}`).subscribe(res => {
          this.selectedDados = [];
          this.recarregaDados();
          this.messageService.add({ key: 'previsao-venda', severity: 'success', detail: "Dado excluido com sucesso.", life: 3000 });
        }, (error) => {
          this.selectedDados = [];
          this.messageService.add({ key: 'previsao-venda', severity: 'warn', detail: error.error.message, life: 5000 });
        });
      },
    });
  }
  
  removerRegistros() {
    this.confirmationService.confirm({
      key: 'previsao-venda',
      message: 'Tem certeza de que deseja apagar os dados?',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        console.log(this.selectedDados);
        let dados: any[] = [];

        this.selectedDados.forEach(res => dados.push({
          id_dealer: res.id,
          id_categoria_venda: res.id_categoria_venda,
          ano: res.ano,
          mes: res.mes
        }));

        const objetoListaDelete = { dados };

        this.service.putDados(`/previsaoVenda/exclusaoMultipla`, objetoListaDelete).subscribe(res => {
          this.selectedDados = [];
          this.recarregaDados();
          this.messageService.add({ key: 'previsao-venda', severity: 'success', detail: "Dado excluido com sucesso.", life: 3000 });
        }, (error) => {
          this.selectedDados = [];
          this.messageService.add({ key: 'previsao-venda', severity: 'warn', detail: error.error.message, life: 5000 });
        });
      },
    });
  }

  exportExcel() {
    let registros = [];
    this.service.getDados(`/previsao_venda?id=${this.filtrosNew.id}&id_dealer=${this.filtrosNew.id_dealer}&id_categoria_venda=${this.filtrosNew.id_categoria_venda}&mes=${this.filtrosNew.mes}&ano=${this.filtrosNew.ano}`).subscribe(res => {
      registros = res.dados;

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};
          this.cols.forEach(c => linha[(c.header)] = (r[c.field]));

          if (linha.hasOwnProperty('Ações')) {
            delete linha['Ações'];
          }

          return linha;
        }));
      }
    });
  }

  showFilters() {
    this.exibeFiltros = true;
  }

  retornaAplicarFiltros(filtros: IFiltros) {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.filtrosNew = filtros;
    this.exibeFiltros = false;
    this.retornaDados();
  }

  retornaRecarregaDados(event: any) {
    this.recarregaDados();
  }

  retornaFecharModalCadastro(dialog: boolean) {
    this.exibeCadastro = dialog;
  }

  retornaFecharModalFiltros(dialog: boolean) {
    this.exibeFiltros = dialog;
  }
}
